import script from "./myIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./myIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__